import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './admin.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ClientsComponent } from './clients/clients.component';
import { ClientComponent } from './client/client.component';
import { ViewGroupComponent } from './view-group/view-group.component';
import { GroupsComponent } from './groups/groups.component';
import { ProfileComponent } from '../shared/profile/profile.component';
import { ConfigComponent } from './config/config.component';
import { MarketingComponent } from '../shared/marketing/marketing.component';
import { UsersComponent } from './users/users.component';
import { ViewUserComponent } from './view-user/view-user.component';
import { SettingsComponent } from '../shared/settings/settings.component';
import { SecurityComponent } from '../shared/security/security.component';
import { AccountComponent } from '../business/account/account.component';
import { ParentProfileComponent } from '../shared/parent-profile/parent-profile.component';
import { AppointmentsComponent } from './appointments/appointments.component';


const routes: Routes = [
    { redirectTo: 'dashboard', pathMatch: 'full', path: '' },
    {
        path: '',
        component: AdminComponent,
        children: [
            { path: '', component: DashboardComponent },
            { path: 'appointments', component: AppointmentsComponent },
            { path: 'dashboard', component: DashboardComponent },
            { path: 'businesses', component: ClientsComponent },
            { path: 'business', component: ClientComponent },
            {
                path: 'business/:id', component: ClientComponent,
                children: [
                    { path: '', redirectTo: 'profile', pathMatch: 'full' },
                    { path: 'profile', component: MarketingComponent },
                ]
            },
            { path: 'categories', component: GroupsComponent },
            { path: 'community-groups', loadChildren: () => import('../community-groups/community-groups.module').then(m => m.AdminCommunityGroupsModule) },
            { path: 'category', component: ViewGroupComponent },
            { path: 'category/:id', component: ViewGroupComponent },
            { path: 'users', component: UsersComponent },
            { path: 'user', component: ViewUserComponent },
            {
                path: 'user/:id', component: ViewUserComponent,
                children: [
                    { redirectTo: 'profile', pathMatch: 'full', path: '' },
                    { path: 'settings', component: SettingsComponent },
                    { path: 'profile', component: ParentProfileComponent },
                    { path: 'marketing', component: MarketingComponent },
                    { path: 'account', component: AccountComponent },
                    { path: 'security', component: SecurityComponent }
                ]
            },
            { path: 'config', component: ConfigComponent },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AdminRoutingModule { }
